// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PayoutManagement-space1-eKOPp {
	margin-bottom: 6px !important;
}

.PayoutManagement-space2-s1yoK {
	margin-bottom: 12px !important;
}

.PayoutManagement-space3-RPlRv {
	margin-bottom: 18px !important;
}

.PayoutManagement-space4-JIpae {
	margin-bottom: 24px !important;
}

.PayoutManagement-space5-J2ZvB {
	margin-bottom: 30px !important;
}

.PayoutManagement-space6-ibwLU {
	margin-bottom: 36px !important;
}

.PayoutManagement-space7-wd2vD {
	margin-bottom: 42px !important;
}

.PayoutManagement-space8-ubwAg {
	margin-bottom: 48px !important;
}

.PayoutManagement-spaceTop1-b7IiG {
	margin-top: 6px !important;
}

.PayoutManagement-spaceTop2-uxCOu {
	margin-top: 12px !important;
}

.PayoutManagement-spaceTop3-p4ep4 {
	margin-top: 18px !important;
}

.PayoutManagement-spaceTop4-h9pYB {
	margin-top: 24px !important;
}

.PayoutManagement-spaceTop5-OJ83l {
	margin-top: 30px !important;
}

.PayoutManagement-spaceTop6-dl3XS {
	margin-top: 36px !important;
}

.PayoutManagement-spaceTop7-We_BJ {
	margin-top: 42px !important;
}

.PayoutManagement-spaceTop8-GYC7o {
	margin-top: 48px !important;
}

.PayoutManagement-noMargin-_ojQZ {
	margin: 0px !important;
}

.PayoutManagement-padding1-ZOsPZ {
	padding-bottom: 6px !important;
}

.PayoutManagement-padding2-SnA0E {
	padding-bottom: 12px !important;
}

.PayoutManagement-padding3-SvEIl {
	padding-bottom: 18px !important;
}

.PayoutManagement-padding4-NfOmv {
	padding-bottom: 24px !important;
}

.PayoutManagement-padding5-ewNQn {
	padding-bottom: 30px !important;
}

.PayoutManagement-padding6-cfXfs {
	padding-bottom: 36px !important;
}

.PayoutManagement-padding7-bwAQq {
	padding-bottom: 42px !important;
}

.PayoutManagement-paddingTop1-zxkDg {
	padding-top: 6px !important;
}

.PayoutManagement-paddingTop2-_LEoH {
	padding-top: 12px !important;
}

.PayoutManagement-paddingTop3-FSFr3 {
	padding-top: 18px !important;
}

.PayoutManagement-paddingTop4-vWQv0 {
	padding-top: 24px !important;
}

.PayoutManagement-paddingTop5-OufyH {
	padding-top: 30px !important;
}

.PayoutManagement-paddingTop6-e0mb4 {
	padding-top: 36px !important;
}

.PayoutManagement-paddingTop7-Ffojr {
	padding-top: 42px !important;
}

.PayoutManagement-noPadding-cMxfX {
	padding: 0px !important;
}

.PayoutManagement-spaceMarginBottom0-kXaOW {
	margin-bottom: 0;
}

.PayoutManagement-textBold-XlC89 {
	font-weight: 500 !important;
}

.PayoutManagement-textBolder-A3fAc {
	font-weight: 700 !important;
}

.PayoutManagement-textNormal-OdhWy {
	font-weight: normal !important;
}

/*New Design Text Colors */

.PayoutManagement-textDarkBlue-slOpd {
	color: rgb(20, 39, 94) !important;
}

.PayoutManagement-textLightBlue-DOcBi {
	color: rgb(57, 87, 106) !important;
}

.PayoutManagement-textLightSandleGreen-atJSX {
	color: rgb(76, 86, 41) !important;
}

.PayoutManagement-textLightBrown-Usaeg {
	color: rgb(115, 79, 33) !important;
}

.PayoutManagement-textMediumMaroon-nSjbN {
	color: rgb(87, 37, 51) !important;
}

.PayoutManagement-textBrown-c9SKf {
	color: rgb(160, 47, 24) !important;
}

.PayoutManagement-textMaroon-xDPYf {
	color: rgb(155, 49, 67) !important;
}

.PayoutManagement-textDarkBrown-OouE9 {
	color: rgb(83, 18, 16) !important;
}

.PayoutManagement-textMediumBrown-tEo8l {
	color: rgb(142, 28, 10) !important;
}

.PayoutManagement-textSkyBlue-e6I8z {
	color: rgb(37, 117, 141) !important;
}

.PayoutManagement-textGray-QyT8O {
	color: rgb(77, 65, 51) !important;
}

.PayoutManagement-errorMessage-_QKKE {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.PayoutManagement-userText-xXCWJ {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.PayoutManagement-panelHeader-sGeXC {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.PayoutManagement-exportSection-ZbbSf {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.PayoutManagement-exportSectionGridSub-uNrVy {
	grid-template-columns: 50% 49% !important;
}

.PayoutManagement-exportText-PmI4G {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.PayoutManagement-exportLinkImg-uUXbi {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.PayoutManagement-exportImg-hxSeQ {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.PayoutManagement-linkBtn-c7IpJ {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.PayoutManagement-table-WbCEA {
	display: table;
}

.PayoutManagement-tableRow-DGnCt {
	display: table-row;
}

.PayoutManagement-tableCell-Sy0Q4 {
	display: table-cell;
	float: none;
}

.PayoutManagement-formGroup-wvio8 {
	margin-bottom: 6px;
}

.PayoutManagement-marginTop0-jstlI {
	margin-top: 0;
}

.PayoutManagement-marginBottom20-NdxZZ {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.PayoutManagement-bannerImageBg-VHHKL {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.PayoutManagement-bannerDelete-h3bsJ {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.PayoutManagement-exportLink-kwXlc {
	padding-top: 10px;
	padding-right: 10px;
}

.PayoutManagement-seachContent-PFt2b {
	padding-left: 0px;
	margin-bottom: 5px;
}

.PayoutManagement-marginBottom9-jj5nC {
	margin-bottom: 9px;
}

.PayoutManagement-spaceTop52-EwPnI {
	margin-top: 52px;
}

.PayoutManagement-profileViewInner-m3PDQ {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.PayoutManagement-profileViewMain-kVBlG {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.PayoutManagement-profileViewlabel-rgJ4r {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.PayoutManagement-profileViewMainContent-UzZt5 {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.PayoutManagement-reviewsFormStar-7BWeF {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.PayoutManagement-reviewsFormStar-7BWeF svg {
	cursor: pointer;
}

.PayoutManagement-addLanguageText-aUNvF {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.PayoutManagement-exportSection-ZbbSf {
		grid-template-columns: 100%;
	}

	.PayoutManagement-spaceTop52-EwPnI {
		margin-top: 18px;
	}

	.PayoutManagement-exportText-PmI4G {
		float: none;
		margin-top: 12px;
	}

	.PayoutManagement-exportSectionGridSub-uNrVy {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.PayoutManagement-profileViewlabel-rgJ4r {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.PayoutManagement-profileViewMainContent-UzZt5 {
		width: 100%;
		text-align: center;
	}

	.PayoutManagement-panelHeader-sGeXC {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `PayoutManagement-space1-eKOPp`,
	"space2": `PayoutManagement-space2-s1yoK`,
	"space3": `PayoutManagement-space3-RPlRv`,
	"space4": `PayoutManagement-space4-JIpae`,
	"space5": `PayoutManagement-space5-J2ZvB`,
	"space6": `PayoutManagement-space6-ibwLU`,
	"space7": `PayoutManagement-space7-wd2vD`,
	"space8": `PayoutManagement-space8-ubwAg`,
	"spaceTop1": `PayoutManagement-spaceTop1-b7IiG`,
	"spaceTop2": `PayoutManagement-spaceTop2-uxCOu`,
	"spaceTop3": `PayoutManagement-spaceTop3-p4ep4`,
	"spaceTop4": `PayoutManagement-spaceTop4-h9pYB`,
	"spaceTop5": `PayoutManagement-spaceTop5-OJ83l`,
	"spaceTop6": `PayoutManagement-spaceTop6-dl3XS`,
	"spaceTop7": `PayoutManagement-spaceTop7-We_BJ`,
	"spaceTop8": `PayoutManagement-spaceTop8-GYC7o`,
	"noMargin": `PayoutManagement-noMargin-_ojQZ`,
	"padding1": `PayoutManagement-padding1-ZOsPZ`,
	"padding2": `PayoutManagement-padding2-SnA0E`,
	"padding3": `PayoutManagement-padding3-SvEIl`,
	"padding4": `PayoutManagement-padding4-NfOmv`,
	"padding5": `PayoutManagement-padding5-ewNQn`,
	"padding6": `PayoutManagement-padding6-cfXfs`,
	"padding7": `PayoutManagement-padding7-bwAQq`,
	"paddingTop1": `PayoutManagement-paddingTop1-zxkDg`,
	"paddingTop2": `PayoutManagement-paddingTop2-_LEoH`,
	"paddingTop3": `PayoutManagement-paddingTop3-FSFr3`,
	"paddingTop4": `PayoutManagement-paddingTop4-vWQv0`,
	"paddingTop5": `PayoutManagement-paddingTop5-OufyH`,
	"paddingTop6": `PayoutManagement-paddingTop6-e0mb4`,
	"paddingTop7": `PayoutManagement-paddingTop7-Ffojr`,
	"noPadding": `PayoutManagement-noPadding-cMxfX`,
	"spaceMarginBottom0": `PayoutManagement-spaceMarginBottom0-kXaOW`,
	"textBold": `PayoutManagement-textBold-XlC89`,
	"textBolder": `PayoutManagement-textBolder-A3fAc`,
	"textNormal": `PayoutManagement-textNormal-OdhWy`,
	"textDarkBlue": `PayoutManagement-textDarkBlue-slOpd`,
	"textLightBlue": `PayoutManagement-textLightBlue-DOcBi`,
	"textLightSandleGreen": `PayoutManagement-textLightSandleGreen-atJSX`,
	"textLightBrown": `PayoutManagement-textLightBrown-Usaeg`,
	"textMediumMaroon": `PayoutManagement-textMediumMaroon-nSjbN`,
	"textBrown": `PayoutManagement-textBrown-c9SKf`,
	"textMaroon": `PayoutManagement-textMaroon-xDPYf`,
	"textDarkBrown": `PayoutManagement-textDarkBrown-OouE9`,
	"textMediumBrown": `PayoutManagement-textMediumBrown-tEo8l`,
	"textSkyBlue": `PayoutManagement-textSkyBlue-e6I8z`,
	"textGray": `PayoutManagement-textGray-QyT8O`,
	"errorMessage": `PayoutManagement-errorMessage-_QKKE`,
	"userText": `PayoutManagement-userText-xXCWJ`,
	"panelHeader": `PayoutManagement-panelHeader-sGeXC`,
	"exportSection": `PayoutManagement-exportSection-ZbbSf`,
	"exportSectionGridSub": `PayoutManagement-exportSectionGridSub-uNrVy`,
	"exportText": `PayoutManagement-exportText-PmI4G`,
	"exportLinkImg": `PayoutManagement-exportLinkImg-uUXbi`,
	"exportImg": `PayoutManagement-exportImg-hxSeQ`,
	"linkBtn": `PayoutManagement-linkBtn-c7IpJ`,
	"table": `PayoutManagement-table-WbCEA`,
	"tableRow": `PayoutManagement-tableRow-DGnCt`,
	"tableCell": `PayoutManagement-tableCell-Sy0Q4`,
	"formGroup": `PayoutManagement-formGroup-wvio8`,
	"marginTop0": `PayoutManagement-marginTop0-jstlI`,
	"marginBottom20": `PayoutManagement-marginBottom20-NdxZZ`,
	"bannerImageBg": `PayoutManagement-bannerImageBg-VHHKL`,
	"bannerDelete": `PayoutManagement-bannerDelete-h3bsJ`,
	"exportLink": `PayoutManagement-exportLink-kwXlc`,
	"seachContent": `PayoutManagement-seachContent-PFt2b`,
	"marginBottom9": `PayoutManagement-marginBottom9-jj5nC`,
	"spaceTop52": `PayoutManagement-spaceTop52-EwPnI`,
	"profileViewInner": `PayoutManagement-profileViewInner-m3PDQ`,
	"profileViewMain": `PayoutManagement-profileViewMain-kVBlG`,
	"profileViewlabel": `PayoutManagement-profileViewlabel-rgJ4r`,
	"profileViewMainContent": `PayoutManagement-profileViewMainContent-UzZt5`,
	"reviewsFormStar": `PayoutManagement-reviewsFormStar-7BWeF`,
	"addLanguageText": `PayoutManagement-addLanguageText-aUNvF`
};
module.exports = ___CSS_LOADER_EXPORT___;
